// @flow

import React from 'react';
import type { Node } from 'react';
import { Row, Col } from '@riseart/antd-provider';
import { Section, Wrapper } from '@riseart/layout';
import type { CmsLayoutProps } from 'shared_components/cms/types';
import { LayoutDefault } from 'shared_components/layouts/Default';
import { renderCmsModule } from 'shared_components/cms/utils';
import { CmsContainer } from 'shared_components/cms/Container';
import { CmsHeadContentRenderer } from 'shared_components/cms/HeadContentRenderer';

/**
 * CmsLayoutSidebarLeft
 *
 * @param {CmsLayoutProps} props
 * @returns {Node}
 */
export const CmsLayoutSidebarLeft = ({ placeholders }: CmsLayoutProps): Node => {
  const renderPlaceholderModule = renderCmsModule(placeholders);
  const sidebarContent = renderPlaceholderModule('cmsSidebar');
  const mainContent = renderPlaceholderModule('cmsContent');

  return (
    <LayoutDefault scrollTopOnPathChange>
      <CmsHeadContentRenderer
        placeholderName="cmsHeadContent"
        moduleLoader={renderPlaceholderModule}
      />
      <Section>
        <Wrapper>
          <CmsContainer>
            <Row>
              {sidebarContent ? (
                <Col xs={24} md={6}>
                  {sidebarContent}
                </Col>
              ) : null}
              {mainContent ? (
                <Col xs={24} md={18}>
                  {mainContent}
                </Col>
              ) : null}
            </Row>
          </CmsContainer>
        </Wrapper>
      </Section>
    </LayoutDefault>
  );
};
